import React from "react";
import { connect } from "react-redux";
import { get, map } from "lodash";

import { Box, Menu, MenuItem, withStyles } from "@material-ui/core";

import images from "../../assets/img/images";
import colors from "../../assets/style/colors";

const styles = {
  plusIcon: {
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    marginTop: "4px",
  },
  menuItem: {
    padding: "13px",
    fontSize: "1em",
    "&:hover": {
      backgroundColor: colors.lightGreenBg,
    },
  },
};

const MenuButton = (props) => {
  const { classes, language, items, onClickItem, mdc=false } = props;

  const [anchorEl, setAnchorEl] = React.useState(null);
  if (mdc){
    return (
      <>
        <Box
          component="span"
          onClick={(event) => setAnchorEl(event.currentTarget)}
        >
          {props.triggerNode || (
            <Box
              className={classes.plusIcon}
              onClick={(event) => setAnchorEl(event.currentTarget)}
            >
              <img
                src={images.plusIconColored}
                alt="plus"
                style={{ marginRight: "5px" }}
              />
              {!props.noArrow && (
                <img src={images.bottomArrowColored} alt="bottom arrow" />
              )}
            </Box>
          )}
        </Box>
        <Menu
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={() => setAnchorEl(null)}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          getContentAnchorEl={null}
        >
          {map(items, (item, index) => (
            <MenuItem
              key={index}
              classes={{ root: classes.menuItem }}
              alignItems="center"
              onMouseEnter={() => {
                // onClickItem(item);
                // setAnchorEl();
              }}
              style={{ paddingLeft: "0px !important", width:"206px" }}
            >
              {get(item, ["icon"]) && (
                <span
                  style={{
                    width: "40px",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <img
                    src={get(item, ["icon"])}
                    alt="icon"
                    height="16px"
                    style={{ maxWidth: "30px" }}
                  />
                </span>
              )}
              {get(item, ["name"]) || get(item, [`name_${language}`])}
            </MenuItem>
          ))}
        </Menu>
      </>
    );
  } else {
    return (
      <>
        <Box
          component="span"
          onClick={(event) => setAnchorEl(event.currentTarget)}
        >
          {props.triggerNode || (
            <Box
              className={classes.plusIcon}
              onClick={(event) => setAnchorEl(event.currentTarget)}
            >
              <img
                src={images.plusIconColored}
                alt="plus"
                style={{ marginRight: "5px" }}
              />
              {!props.noArrow && (
                <img src={images.bottomArrowColored} alt="bottom arrow" />
              )}
            </Box>
          )}
        </Box>
        <Menu
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={() => setAnchorEl(null)}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          getContentAnchorEl={null}
        >
          {map(items, (item, index) => (
            <MenuItem
              key={index}
              classes={{ root: classes.menuItem }}
              alignItems="center"
              onClick={() => {
                onClickItem(item);
                setAnchorEl();
              }}
              style={{ paddingLeft: "0px !important" }}
            >
              {get(item, ["icon"]) && (
                <span
                  style={{
                    width: "40px",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <img
                    src={get(item, ["icon"])}
                    alt="icon"
                    height="16px"
                    style={{ maxWidth: "30px" }}
                  />
                </span>
              )}
              {get(item, ["name"]) || get(item, [`name_${language}`])}
            </MenuItem>
          ))}
        </Menu>
      </>
    );
  }

};

const mapStateToProps = (state) => {
  return {
    language: get(state, ["user", "language"]),
  };
};

export default connect(mapStateToProps)(withStyles(styles)(MenuButton));
